import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { ProfileService } from '../profile/profile.service';

@Injectable()
export class OnboardingTutorialGuard implements CanActivate {

    constructor(
        private router: Router,
        protected authService: AuthService,
        private profileService: ProfileService
    ) { 
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        try {
            const token = await this.authService.getToken();
            if (!token) {
                throw new Error();
            }

            const profile = await this.profileService.me(token);
            if (profile) {
                throw new Error();
            }

            return true;
        } catch(err) {
            this.router.navigate(['../onboarding/start']);
            return false;
        }
    }

}